  <!-- src/components/index.vue -->

<template>
  <section>
    <!--

    <h1 class="flex-grow-1 MainTitleFont textmain">XV'S Portfolio</h1> -->
    
    <!-- Show message if gallery is private -->
    <!-- Show normal gallery if not private and has content -->
    <div v-if="years.length > 0">
      <ArtGalleryLoop v-if="!loading" :artPosts="artPosts" :componentType="'ArtGalleryLoopPart1Image'" :usageType="'galleryPage'" :userId="userId" :userSettings="userSettings"/>
    </div>
    <div v-else-if="isPrivate" class="text-center p-4">
        <p>This section is private</p>
    </div>
    <!-- Show message if no art posts found (but not private) -->
    <div v-else-if="!isPrivate && !loading" class="text-center p-4">
      <p>This section is Empty</p>
    </div>
    <div v-if="loading" class="text-center p-4 loading-container textmain align-items-center d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </section>
</template>


<script>
  import 'bootstrap/dist/css/bootstrap.min.css';
  import ArtGalleryLoop from '@/ArtGalleryLoop.vue';
  import AOS from 'aos';
  import 'aos/dist/aos.css'; // Import AOS styles
  export default {
    name: 'App',
    props: ['userId', 'userSettings'], // Accept userId and userSettings props
    components: {
    ArtGalleryLoop,
    },
    // Hide the data until user selects it
    data() {
      return {
        showApp: true,
        years: [],
        yearsByCategory: [],
        artPosts: [],
        isPrivate: false, // Track if gallery is private
        loading: true, // Add loading state
        hoverText: 'Hover over an icon to see my what it is.',
      };
    },
    methods: {
      formatYear(year) {
        return year === 2016 ? 'Archive' : year;
      },
      preloadImages(artPosts) {
        const imageUrls = artPosts.map(post => post.image_url).filter(url => url);
        const imagePromises = imageUrls.map(url => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = resolve;
            img.onerror = resolve; // Resolve even on error to not block other images
            img.src = url;
          });
        });
        
        Promise.all(imagePromises).then(() => {
          this.loading = false; // Set loading to false when all images are preloaded
          // Refresh AOS after images are loaded
          this.$nextTick(() => {
            AOS.refresh();
          });
        });
      },
    },
    mounted(){
      AOS.init();
    },
    created() {
    // Only fetch if userId is provided
    if (!this.userId) {
      console.warn('No userId provided to ArtSection');
      return;
    }

    let apiUrl;
    if (process.env.NODE_ENV === 'production') {
      apiUrl = `/api/artPosts/user/${this.userId}`;
    } else {
      apiUrl = `http://localhost:3002/api/artPosts/user/${this.userId}`;
    }
    
    fetch(apiUrl)
      .then(response => {
        if (response.status === 403) {
          // Gallery is private
          this.isPrivate = true;
          throw new Error('Gallery is private');
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Fetched data:', data);

        // Get all unique years from all categories
        const allYears = data.map(item => item.year);
        this.years = [...new Set(allYears)].sort((a, b) => b - a); // Sort years descending

        // Sort all art posts by year descending (2026 first), then take the top 50
        const sortedPosts = [...data].sort((a, b) => parseInt(b.year) - parseInt(a.year));
        this.artPosts = sortedPosts.slice(0, 50);

        // Preload only the images we're actually going to display
        this.preloadImages(this.artPosts);
      })
      .catch(error => {
        console.error('Error fetching art posts:', error);
        this.loading = false; // Set loading to false even on error
        if (error.message !== 'Gallery is private') {
          // Only log non-privacy errors
          console.error('Unexpected error:', error);
        }
      });
    },
  }
</script>

<style scoped>
/* Remove glow effect on hover */
li.portfolio h3:hover {
  /* Override the textmainglow class properties */
  text-shadow: none !important;
  /* Or add your own hover styles */
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

/* Restore glow for active year even on hover */
li.portfolio h3.textmainglow:hover {
  text-shadow: inherit !important;
  opacity: 1;
}
</style>
